// extracted by mini-css-extract-plugin
module.exports = {"productInfo":"ProductInfo_productInfo__2Lce9"};